import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
} from '@angular/core';

@Directive({
  standalone: true,
  selector: '[ucxJsHighlight]',
})
export class HighlightDirective {
  private _hoverScaleUnit = 1;

  constructor(private element: ElementRef, private cdr: ChangeDetectorRef) {}

  @HostBinding('style.transform') get buttonHoverScale() {
    return `scale(${this._hoverScaleUnit})`;
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.scaleUp();
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.scaleDown();
  }

  @HostListener('focus') onFocus() {
    this.scaleUp();
  }

  @HostListener('blur') onBlur() {
    this.scaleDown();
  }

  private scaleUp() {
    const width = (this.element.nativeElement as HTMLElement).clientWidth;
    this._hoverScaleUnit = 1 + 8 / width;
    this.cdr.markForCheck();
  }

  private scaleDown() {
    this._hoverScaleUnit = 1;
    this.cdr.markForCheck();
  }
}
